import React from "react";
import {Container, Row, Spinner} from "react-bootstrap";

export function LoadingContainer({style}) {
    return <Container style={style}>
        <Row>
            <div className="d-flex justify-content-center align-items-center no-border">
                <Spinner animation="border" style={{width: "5rem", height: "5rem"}}/>
            </div>
        </Row>
    </Container>
}

export default () => {
  return (
    <div className="row center" style={{ padding: 50 }}>
      <div className="col s12">
        <div className="preloader-wrapper big active">
          <div className="spinner-layer spinner-blue">
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
